import { GetQuickFilterTextParams } from 'ag-grid-community';
import * as moment from 'moment';
import { formatters } from '../../core';
import { isEmpty, chain } from 'lodash';

export function booleanRenderer(x: { value: boolean }) {
    return formatters.formatBoolean(x.value);
}

export function dateRenderer(x: { value: moment.Moment }) {
    return formatters.formatDate(x.value);
}

export function dateArrayRenderer(value: moment.Moment[]) {
    if (isEmpty(value)) {
        return '';
    }

    const collectionDates = chain(value)
    .map(x => dateRenderer({ value: x }))
    .value()
    .join(', ');
    return collectionDates;
}

export function dateTimeRenderer(x: { value: moment.Moment }) {
    return formatters.formatDateTime(x.value);
}

export function booleanQuickFilterText(params: GetQuickFilterTextParams) {
    return formatters.formatBoolean(params.value);
}

export function momentExporter(value: moment.Moment) {
    return value.toDate();  // we need this because agGrid is a way too smart when it comes to exporting data in xls format
}